import React, { createContext, useContext, useState } from "react";
import SearchPage from "../components/SearchPage/SearchPage";
import Header from "../components/Header";

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [searchData, setSearchData] = useState(null);
  // console.log(searchQuery);

  // return (
  //   <SearchContext.Provider value={{
  //     searchQuery,
  //     setSearchQuery,
  //     searchData,
  //     setSearchData
  //   }}>
  //     <div className="pt-24">
  //     <Header />
  //     {searchQuery!==''?<SearchPage searchQuery={searchQuery}/>:children}
  //     </div>
  //   </SearchContext.Provider>
  // );
  return (
    <SearchContext.Provider
      value={{
        searchQuery,
        setSearchQuery,
        searchData,
        setSearchData,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error("useSearch must be used within a SearchProvider");
  }
  return context;
};
